import type { EstimationModelItemGroupResponse } from '@/api/schema/data-contracts';

import type { CostEstimationItemsEditFormModel, CostEstimationItemsTableRecord } from '../model';
import type { FormModelItemWithOriginalData } from './model';

export const mapFormModelItemWithOriginalData = (
  formModel: CostEstimationItemsEditFormModel,
  estimationItems: CostEstimationItemsTableRecord[],
  group: EstimationModelItemGroupResponse | undefined,
): FormModelItemWithOriginalData[] => {
  if (!group) {
    return [];
  }

  return formModel.estimationItems
    .filter((x) => x.groupId === group?.id)
    .map((formModelItem) => ({
      id: formModelItem.id,
      formModelItemIndex: formModel.estimationItems.findIndex((x) => x.id === formModelItem.id),
      formModelItem,
      originalData: estimationItems.find(
        (estimationItem) => estimationItem.id === formModelItem.id,
      ),
    }));
};
